var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cube-2",
    transform: "translate(-113.000000, -91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cube",
    transform: "translate(69.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn",
    transform: "translate(44.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Circle-Color",
    fill: "#FFFFFF",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 12.000000)",
    fill: "#051C2C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.86585366,8.45121951 L6.25609756,8.45121951 L6.25609756,22.4268293 L1.86585366,22.4268293 L1.86585366,8.45121951 Z M17.2842851,8.08536585 C21.6850445,8.08536585 22.5,11.0338137 22.5,14.8012749 L22.5,22.5 L18.1807361,22.5 L18.1802281,15.3176337 C18.1723545,13.73197 18.0424406,11.8528271 15.8988608,11.8528271 C13.6169855,11.8528271 13.2910034,13.6546563 13.2910034,15.4564856 L13.2910034,22.4180987 L8.97173945,22.4180987 L8.97173945,8.49487251 L13.0465167,8.49487251 L13.0465167,10.3786031 L13.1280123,10.3786031 C13.6984811,9.23198448 15.1654009,8.08536585 17.2842851,8.08536585 Z M4.06097561,1.5 C5.46538159,1.5 6.62195122,2.65656963 6.62195122,4.06097561 C6.62195122,5.46538159 5.46538159,6.62195122 4.06097561,6.62195122 C2.65656963,6.62195122 1.5,5.46538159 1.5,4.06097561 C1.5,2.57395751 2.65656963,1.5 4.06097561,1.5 Z",
    id: "Icon-Color"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.78a74b20347eeb53ebb82b517916a621.svg";
export { ForwardRef as ReactComponent };